import MonthNames from './monthNames';
import VipTiers from '@maxduel/constants/vipTiers';

const DEV_ENV_LIST = ['local', 'maxquest', 'development_maxduel'];

export { MonthNames, VipTiers, DEV_ENV_LIST };
